import Vue from 'vue'

import Vuetify from 'vuetify/lib/framework'

import 'roboto-fontface/css/roboto/roboto-fontface.css'

import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({

    theme: {

        themes: {

            light: {

                primary: '#205b91',

                secondary: '#6697c4',

                accent: '#8c9eff',

                error: '#ef4136'

            },

        },

    },

})
